import React from 'react';

import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import PillGroup from 'components/PillGroup';
import VenueMultiSelector from 'components/VenueMultiSelector';
import { venuePropTypes } from 'constants/propTypes';
import { bem } from 'helpers/class-name';

import { DATE_RANGE_PRESET } from './SkuOrderReports.filters';
import messages from './SkuOrderReports.messages';
import SkuReportDateRangeFilter from './SkuReportDateRangeFilter';
import './SkuOrderReportsFilters.scss';

const { block, element } = bem('sku-order-reports-filters');

const PRESET_MESSAGES = {
  [DATE_RANGE_PRESET.LAST_7_DAYS]: messages.last7Days,
  [DATE_RANGE_PRESET.LAST_30_DAYS]: messages.last30Days,
  [DATE_RANGE_PRESET.LAST_6_MONTHS]: messages.last6Months,
};

const SkuOrderReportsFilters = ({
  venues,
  selectedVenueIds,
  onVenuesChange,
  range,
  onRangeChange,
  preset,
  onPresetSelect,
}) => {
  const intl = useIntl();

  const presetOptions = Object.entries(PRESET_MESSAGES).map(([key, label]) => ({
    key,
    label: intl.formatMessage(label),
  }));

  return (
    <div className={block()}>
      <div className={element('venues')}>
        <VenueMultiSelector
          attachment="left"
          disabled={venues.length < 2}
          hideSingleVenue={false}
          labels={{
            label: messages.locationLabel,
            allSelected: messages.allLocations,
            selectedCount: messages.locationsSelected,
          }}
          onChange={onVenuesChange}
          selectedVenueIds={selectedVenueIds}
          venues={venues}
        />
      </div>
      <div className={element('date')}>
        <SkuReportDateRangeFilter value={range} onChange={onRangeChange} />
      </div>
      <PillGroup
        className={element('presets')}
        options={presetOptions}
        value={preset}
        onChange={key => {
          if (key !== preset) onPresetSelect(key);
        }}
      />
    </div>
  );
};

SkuOrderReportsFilters.propTypes = {
  venues: PropTypes.arrayOf(PropTypes.shape(venuePropTypes)).isRequired,
  selectedVenueIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  onVenuesChange: PropTypes.func.isRequired,
  range: PropTypes.shape({
    from: PropTypes.instanceOf(Date).isRequired,
    to: PropTypes.instanceOf(Date).isRequired,
  }).isRequired,
  onRangeChange: PropTypes.func.isRequired,
  preset: PropTypes.oneOf(Object.values(DATE_RANGE_PRESET)),
  onPresetSelect: PropTypes.func.isRequired,
};

export default SkuOrderReportsFilters;
